import * as React from "react";
import dynamic from "next/dynamic";
// import { WebHeader } from "litb-header";
import styled, { createGlobalStyle } from "styled-components";

import ErrorPage from "./components/ErrorPage";
import MegatronFrontForWeb from "./components/MegatronFrontForWeb";

import { MainProps } from "../index";
import { setSentryCatchOnRequest } from "utils/sentryEvent";
import { onChangeHeaderLang } from "utils/language";
import { isNotBlankArray } from "utils/array";
import { Platform } from "utils/runtime";
import { isLocalDevelop } from "ts-constants";

const WebHeader = dynamic<any>(
	import("litb-header").then((mode) => mode.WebHeader),
	{
		ssr: true,
	},
);
const WebFooter = dynamic<any>(
	import("litb-header").then((mode) => mode.WebFooter),
	{
		ssr: true,
	},
);

const MainContainer = styled.section`
	min-height: 409px;
	min-width: 1200px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
	grid-row-gap: 12px;
	padding: 15px 0;
`;
const GlobalStyle = createGlobalStyle`
	:root {
			--loaderWidth: 250px;
			--loaderDotSize: 20px;
			--fontBold: "Avenir-Black";
			--fontMedium: "Avenir-Book";
		html, body {
			font-size: 12px;
		}
	}
`;
const NewPageTipsDom = styled.div`
	width: 100%;
	padding: 10px;
	text-align: center;
	font-size: 16;
	color: red;
`;
export const NewPageTips = () => {
	return (
		<NewPageTipsDom>
			<a href="litb://login?mian_page=login" target="_blank" title="仅仅为了测试ios的">
				仅仅为了测试ios的 litb://login
			</a>
			此页面为新页面，做新老页面区分，不影响测试
		</NewPageTipsDom>
	);
};

export default function PC(props: MainProps) {
	const { page, frontModules, runtime } = props;
	const isPageDisabled = !page || page.isDisable;
	const defaultProps = {
		isDev: isLocalDevelop(runtime?.hostname),
		isUat: runtime?.isUat ?? false,
		cookies: runtime?.cookies || {},
		runtime: {
			languageCode: runtime?.languageCode,
			currency: runtime?.currency,
			countryCode: runtime?.countryCode3,
			countryCode2: runtime?.countryCode2,
			sid: runtime?.sid,
			sessionKey: runtime?.sessionKey,
			platform: Platform.WEB,
			multiLanImgKey: runtime?.multiLanImgKey,
			countryId: runtime?.countryId,
		},
	};

	return (
		<main style={{ overflowX: "hidden" }}>
			<WebHeader
				{...defaultProps}
				onChangeLanguage={onChangeHeaderLang}
				onSentryCatch={setSentryCatchOnRequest}
			/>
			{runtime.isUat && <NewPageTips />}
			<MainContainer
				key={"PAGE"}
				style={{
					backgroundColor: page?.ui?.bgColor || "#f7f7f7",
				}}
			>
				<GlobalStyle />
				{isPageDisabled || !isNotBlankArray(frontModules) ? (
					<ErrorPage language={runtime.languageCode} />
				) : (
					<MegatronFrontForWeb {...props} />
				)}
			</MainContainer>
			<section style={{ minHeight: "789px" }}>
				<WebFooter {...defaultProps} />
			</section>
		</main>
	);
}
